import PropTypes from 'prop-types'
import commonDriverAPI from '~/api/desktop/commonDriver'
import Dialog from '~/components/Dialog'
import ConfigDialogTab from '~/components/Dialog/ConfigDialogTab'
import { JsonSchemaResponse } from '~/types/JsonSchema.interface'
import { INSTRUMENT_DISPLAY_NAMES } from '~/utils/instrument'
import cs from './driver_config_dialog.scss'

interface DriverConfigDialogProps {
  isOpen: boolean
  onClose: () => void
  instrumentName: string
  instrumentType: string
  onConfigUpdated?: () => void
}

const DriverConfigDialog = ({
  isOpen,
  onClose,
  instrumentName,
  instrumentType,
  onConfigUpdated,
}: DriverConfigDialogProps) => {
  if (!instrumentName) return null

  const instrumentTypeDisplay = INSTRUMENT_DISPLAY_NAMES[instrumentType]

  const renderDriverSettings = () => {
    const api = {
      getSchema: async () => {
        const response = await commonDriverAPI.getConfigSchemaV2(instrumentName)

        return {
          schema: response.config_schema,
        } as unknown as JsonSchemaResponse
      },
      setConfig: async (newConfig, overwrite) =>
        commonDriverAPI.setConfigV2(instrumentName, newConfig, overwrite, true),
      getConfig: async () => {
        const response = await commonDriverAPI.getConfigV2(instrumentName)
        return response.config
      },
    }
    return (
      <ConfigDialogTab api={api} onClose={onClose} onConfigUpdated={onConfigUpdated} />
    )
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} className={cs.driverConfigDialog}>
      <div className={cs.title}>Edit {instrumentTypeDisplay} Settings</div>
      {renderDriverSettings()}
    </Dialog>
  )
}

DriverConfigDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  instrumentName: PropTypes.string,
  instrumentType: PropTypes.string,
}

export default DriverConfigDialog
